import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Avenir', 'sans-serif'],
  },
  palette: {
    primary: {
      main: 'rgb(0, 160, 223)',
      contrastText: '#fff',
    },
  },
  props: {
    MuiButton: {
      disableRipple: true,
    },
    MuiButtonGroup: {
      disableRipple: true,
    },
    MuiInputLabel: {
      shrink: true,
    },
    MuiCheckbox: {
      disableRipple: true,
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          margin: '1.25rem 0',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 1)',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderRadius: '2px',
          '&::before': { borderBottom: '1px solid #CADAE0' },
          '&:hover': { borderBottom: '1px solid #CADAE0' },
        },
      },
    },
    MuiButton: {
      root: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          borderRadius: '2px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'black',
          '&$disabled': {
            color: 'black',
          },
          '&$-shrink': {
            color: 'red',
          },
        },
        shrink: {
          transformOrigin: 'top left',
          transform: 'translate(0px, -1.2rem) scale(0.75)',
          fontSize: '100%',
          color: 'rgb(0, 160, 223)',
          '&$disabled': {
            color: 'black',
          },
        },
      },
    },
  },
});

export default theme;
